import { Dropdown } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import React, { useRef, useState } from 'react';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import { useClickAway } from 'react-use';
import {
  addImageThumbnail,
  setModalUiContent
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { THUMBNAIL_SOURCE } from '../../config/constants';

interface CustomToggleProps {
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const ThumbnailDropDown: React.FC<any> = ({ platform }) => {
  const dispatch = useDispatch();
  const postTypeSelected = useSelector(
    (state: any) => state.lomavisCreator.postTypeSelected
  );

  const postTypeMediaArray = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData?.[platform]?.media
  );
  const ref = useRef(null);

  const [showDropdown, setShowDropdown] = useState(false);
  const { t } = useTranslate();
  useClickAway(ref, () => {
    setShowDropdown(false);
  });

  const location_slug = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.lomavisCreatorConfig?.location?.slug
  );
  const mediaLibraryUrl = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.lomavisCreatorConfig?.media_library?.url
  );

  const [popupParams, setPopupParams] = useState({
    width: 1000,
    height: 600,
    left: (window.innerWidth - 1000) / 2,
    top: 100,
    openCropper: true,
    currentPlatform: platform,
    maxMediaFiles: 10,
    videoSelectAllowed: true,
    location_slug: location_slug
  });

  const openMediaLibrary = () => {
    const {
      width,
      height,
      left,
      top,
      openCropper,
      currentPlatform,
      maxMediaFiles,
      videoSelectAllowed,
      location_slug
    } = popupParams;

    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,directories=no,copyhistory=no,width=${width},height=${height},left=${left},top=${top}`;
    const url = `${window.location.origin}${mediaLibraryUrl}?mode=popup&trigger=id_imageWrapperId&openCropper=${openCropper}&maxMediaFiles=${maxMediaFiles}&videoSelectAllowed=${videoSelectAllowed}`;

    const newWindow = window.open(url, 'mediaLibraryPopup', params);
    if (newWindow) {
      newWindow.focus();
      window.addEventListener(
        'LomavisMediaLibraryPopUpFileSelected',
        handleFileSelection
      );
    }
  };

  const handleFileSelection = (event) => {
    const mediaList = JSON.parse(event.detail?.data);

    dispatch(
      addImageThumbnail({
        url: mediaList[0].original_asset,
        file: '',
        platform: platform
      })
    );

    dispatch(
      setModalUiContent({
        modal: 'thumbnail',
        attribute: 'platform',
        value: platform
      })
    );
    dispatch(
      setModalUiContent({
        modal: 'thumbnail',
        attribute: 'source',
        value: THUMBNAIL_SOURCE.MEDIA_LIBRARY
      })
    );
    dispatch(
      setModalUiContent({
        modal: 'thumbnail',
        attribute: 'toggle',
        value: true
      })
    );

    window.removeEventListener(
      'LomavisMediaLibraryPopUpFileSelected',
      handleFileSelection
    );
  };

  const thumbnailUploadOptions = [
    {
      text: t('lomavisCreator.thumbnail.uploadFile'),
      icon: 'fa-solid fa-arrow-up-from-bracket',
      onClick: () => {
        dispatch(
          setModalUiContent({
            modal: 'thumbnail',
            attribute: 'platform',
            value: platform
          })
        );
        dispatch(
          setModalUiContent({
            modal: 'thumbnail',
            attribute: 'source',
            value: THUMBNAIL_SOURCE.UPLOAD_FILE
          })
        );
        dispatch(
          setModalUiContent({
            modal: 'thumbnail',
            attribute: 'toggle',
            value: true
          })
        );
      }
    },
    {
      text: t('lomavisCreator.thumbnail.fromVideo'),
      icon: 'fa-solid fa-film',
      onClick: () => {
        dispatch(
          setModalUiContent({
            modal: 'thumbnail',
            attribute: 'platform',
            value: platform
          })
        );
        dispatch(
          setModalUiContent({
            modal: 'thumbnail',
            attribute: 'source',
            value: THUMBNAIL_SOURCE.SELECT_VIDEO
          })
        );
        dispatch(
          setModalUiContent({
            modal: 'thumbnail',
            attribute: 'toggle',
            value: true
          })
        );
      }
    },
    {
      text: t('lomavisCreator.thumbnail.mediaLibrary'),
      icon: 'fa-solid fa-photo-film',
      onClick: () => {
        openMediaLibrary();
      }
    }
  ];

  const CustomToggle = React.forwardRef<HTMLDivElement, CustomToggleProps>(
    ({ children, onClick }, ref) => (
      <div
        ref={ref}
        onClick={(e) => setShowDropdown(!showDropdown)}
        className="cursor-pointer"
      >
        {children}
      </div>
    )
  );

  return (
    <div
      className="dropdown w-100"
      onClick={() => setShowDropdown(!showDropdown)}
      ref={ref}
    >
      <div
        id="dropdown-thumbnail w-100"
        className="justify-content-start align-items-center mx-4"
        style={{}}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        role="button"
      >
        <div className="d-flex justify-content-center gap-2 btn btn-outline-light border btn-sm w-100">
          <div className="d-flex gap-2 align-items-center">
            <i
              style={{ fontSize: '16px' }}
              className="fa-duotone fa-file-image"
            ></i>
            <span className="text-muted fw-bolder">
              {t('lomavisCreator.uploadThumbnail')}
            </span>
          </div>
        </div>
      </div>

      <div className="dropdown-menu">
        {thumbnailUploadOptions.map((option, index) => {
          return (
            <div
              key={index}
              id={index + 'thumbnail'}
              onClick={option?.onClick}
              className="dropdown-item cursor-pointer"
            >
              <div className="d-flex gap-2">
                <i
                  style={{ fontSize: '16px' }}
                  className={`fa-duotone ${option.icon}`}
                ></i>
                <span className="text-muted fw-bolder">{option.text}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThumbnailDropDown;
